import React from 'react';
import { Navigate } from 'react-router-dom';

import { hasAnyRole } from '../config/routeAccess';
import { getUserData, isAuthenticated } from '../utils/tokenStorage';

function PrivateRoute({ children, roles }) {
  const authenticated = isAuthenticated();

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles && roles.length > 0) {
    const userData = getUserData();
    if (!userData) {
      return <Navigate to="/login" replace />;
    }

    if (!hasAnyRole(userData.roles, roles)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}

export default PrivateRoute;